import { Component, computed, HostListener, Injector, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Observable } from 'rxjs';
import { SkeletonLoaderComponent } from '../../shared/components/skeleton-loader/skeleton-loader.component';
import { InputStatesService } from '../../shared/services/input-states.service';
import { Breakpoints } from '../../shared/types/breakpoints';
import { GetRepairResponse } from '../mmr/mmr.types';
import { MmrService } from '../mmr/services/mmr.service';
import { BookingProgressBarComponent } from './components/booking-progress-bar/booking-progress-bar.component';
import { ClaimsFormService } from './components/claims-form/services/claims-form.service';
import { SummaryPanelComponent } from './components/summary-panel/summary-panel.component';

@Component({
  selector: 'app-book-claim',
  imports: [RouterOutlet, SummaryPanelComponent, BookingProgressBarComponent, SkeletonLoaderComponent],
  templateUrl: './book-claim.component.html',
  styleUrl: './book-claim.component.scss',
  host: {
    class: 'flex lg-pt-20 lg-pl-16 lg-pr-16 lg-pb-20',
  },
})
export class BookClaimComponent implements OnInit {
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (!this.vm.showSummaryPanel) return;

    // Hide the panel if screen goes above medium breakpoint
    if (event.target.innerWidth > Breakpoints.lg) {
      this.showSummaryPanel.set(false);
    }
  }

  planNumber = signal<string>('');

  showSummaryPanel = signal(false);

  repairValue: Observable<GetRepairResponse> | undefined;

  private viewModel = computed(() => {
    const { plan } = this.mmrService.planClaimsDetails;
    return {
      isLoading: this.claimsFormService.state.isLoading,
      titleDetails: plan.value()?.headingDisplay,
      showSummaryPanel: this.showSummaryPanel(),
      mmrPageLink: `${this.planNumber()}/claims`,
      currentStep: this.claimsFormService.state.currentClaimSteps,
      isClaimStarted: !!this.claimsFormService.state.currentClaim,
    };
  });

  get vm() {
    return this.viewModel();
  }

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly injector: Injector,
    private readonly mmrService: MmrService,
    private readonly claimsFormService: ClaimsFormService,
    private readonly inputStateService: InputStatesService
  ) {}

  ngOnInit() {
    this.inputStateService.resetState();
    this.planNumber.set(this.route.snapshot.params['planNumber']);

    this.claimsFormService.setPlanNumber(this.planNumber());
    this.mmrService.loadPlanClaims(this.planNumber());
  }
}
